// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M7.39 3.366a1.252 1.252 0 0 0 0 1.768l6.424 6.439a.252.252 0 0 1 0 .354L7.39 18.366a1.248 1.248 0 0 0 1.763 1.768l7.48-7.5a1.252 1.252 0 0 0 0-1.768l-7.48-7.5a1.245 1.245 0 0 0-1.763 0Z" />
    </svg>
  );
};

const ChevronRightIcon = Icon;
export default ChevronRightIcon;
